import classNames from "classnames";
import { useRef, ReactNode } from "react";
import AppPortal from "../AppPortal";
import { useLockBodyScroll } from "../../hooks/lockedBody";
import { useOutsideClick } from "../../hooks/outsideClick";
import "./AppModal.css";

interface AppModalProps {
  isVisible: boolean;
  onChange: (visible: boolean) => void;
  className?: string;
  children: ReactNode;
}

export default function AppModal({
  isVisible,
  onChange,
  className,
  children,
}: AppModalProps) {
  const modalContainer = useRef<HTMLDivElement | null>(null);

  useLockBodyScroll(isVisible);
  useOutsideClick(modalContainer, () => onChange(false));

  if (!isVisible) return null;

  return (
    <AppPortal>
      <div className={classNames("app-modal", className)} role="dialog">
        <div ref={modalContainer} className="app-modal-container">
          {children}
        </div>
      </div>
    </AppPortal>
  );
}
